// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__9GXGE","label":"LabeledBox_label__Wb5xZ"};